document.documentElement.classList.add('df-motion-ready');

document.addEventListener('DOMContentLoaded', () => {

  /* =========================================
     PRODUKTE – SCROLL REVEAL
     ========================================= */

const productSections = document.querySelectorAll(
  'main[data-template="index"] .ui-test-product-list'
);

productSections.forEach((productSection) => {
  const productObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('df-products-visible');
          productObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px'
    }
  );

  productObserver.observe(productSection);
});


  /* =========================================
     PREMIUM QUALITÄT / FAIRER PREIS /
     MADE IN GERMANY
     ========================================= */

  const benefitTitles = [
    'Premium Qualität',
    'Fairer Preis',
    'Made in Germany'
  ];

  const benefitBlocks = benefitTitles
    .map((title) => {
      const titleElement = [...document.querySelectorAll('h1,h2,h3,h4,div')]
        .find((element) => element.textContent?.trim() === title);

      return titleElement?.closest('.group-block');
    })
    .filter(Boolean);

  if (benefitBlocks.length === 3) {

    benefitBlocks.forEach((block) => {
      block.classList.add('df-benefit-item');
    });

    const benefitSection = benefitBlocks[0].closest('.shopify-section');

    if (benefitSection) {
      benefitSection.classList.add('df-benefits-section');

      const benefitObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              benefitSection.classList.add('df-benefits-visible');
              benefitObserver.unobserve(benefitSection);
            }
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -5% 0px'
        }
      );

      benefitObserver.observe(benefitSection);
    }
  }

});